var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "delete-prompt" }, on: { click: _vm.deletePrompt } },
    [
      _c("span", [_vm._v(_vm._s(_vm.prompt))]),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-times ml-1" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }